// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var getSlateMembers = function (slate) {
    return Object.fromEntries(slate.contests.map(function (_a) {
        var contest = _a.contest, candidates = _a.candidates;
        return [
            contest.id,
            candidates.map(function (candidate) { return candidate.id; }),
        ];
    }));
};
export var ESlateSelectionStatus;
(function (ESlateSelectionStatus) {
    ESlateSelectionStatus["NONE"] = "none";
    ESlateSelectionStatus["PARTLY"] = "partly";
    ESlateSelectionStatus["MIXED"] = "mixed";
    ESlateSelectionStatus["ALL"] = "all";
})(ESlateSelectionStatus || (ESlateSelectionStatus = {}));
/**
 * How much of a slate the ballot currently holds, read from the ordinary
 * candidate selections. No slate choice is stored anywhere: a member chosen
 * one by one counts exactly like one chosen through the slate.
 *
 * Only the contests the slate covers are looked at, so a partial slate whose
 * members are all selected is ALL whatever the other offices hold.
 */
export var getSlateSelectionSummary = function (members, selection) {
    var selectedMemberIds = [];
    var total = 0;
    var hasOutsideChoice = false;
    var _loop_1 = function (contestId, memberIds) {
        var contest = selection === null || selection === void 0 ? void 0 : selection.find(function (decoded) { return decoded.contest_id === contestId; });
        if (!contest) {
            return "continue";
        }
        if (contest.is_explicit_invalid) {
            hasOutsideChoice = true;
        }
        for (var _c = 0, _d = contest.choices; _c < _d.length; _c++) {
            var choice = _d[_c];
            var isMember = memberIds.includes(choice.id);
            var isSelected = choice.selected > -1;
            if (isMember) {
                total += 1;
                if (isSelected) {
                    selectedMemberIds.push(choice.id);
                }
            }
            else if (isSelected) {
                hasOutsideChoice = true;
            }
        }
    };
    for (var _i = 0, _a = Object.entries(members); _i < _a.length; _i++) {
        var _b = _a[_i], contestId = _b[0], memberIds = _b[1];
        _loop_1(contestId, memberIds);
    }
    var selected = selectedMemberIds.length;
    var status = ESlateSelectionStatus.PARTLY;
    if (selected === 0) {
        status = ESlateSelectionStatus.NONE;
    }
    else if (hasOutsideChoice) {
        status = ESlateSelectionStatus.MIXED;
    }
    else if (selected === total) {
        status = ESlateSelectionStatus.ALL;
    }
    return { status: status, selected: selected, total: total, selectedMemberIds: selectedMemberIds };
};
